import { CandidateCreateForm } from "core/candidate/create-form";

export const CreatePage = () => {
  return <CandidateCreateForm />;
};
